import api from '@/services/utils/apiInstance'

class CollaboratorsService {
  async getPaginatedAccountCollaboratorsList(
    search,
    sort,
    order,
    page,
    limit,
    accountId = null,
    signal = undefined
  ) {
    let url = ''
    if (accountId) {
      url =
        '/distributor/account/' +
        accountId +
        '/collaborators/list?search=' +
        encodeURIComponent(search) +
        '&sort=' +
        sort +
        '&order=' +
        order +
        '&page=' +
        page +
        '&limit=' +
        limit
    } else {
      url =
        '/account/collaborators/list?search=' +
        encodeURIComponent(search) +
        '&sort=' +
        sort +
        '&order=' +
        order +
        '&page=' +
        page +
        '&limit=' +
        limit
    }
    const response = await api.get(url, { signal })
    return response.data
  }

  async getCollaboratorFromNetwork(accountId, collaboratorId) {
    const response = await api.get(
      `/distributor/account/${accountId}/collaborators/${collaboratorId}`
    )
    return response.data
  }

  async createNetworkCollaborator(data, accountId) {
    const response = await api.post(`/distributor/account/${accountId}/collaborators`, data)
    return response.data
  }

  async updateNetworkCollaborator(data, accountId) {
    const response = await api.put(
      `/distributor/account/${accountId}/collaborators/${data.technical_id}`,
      data
    )
    return response.data
  }

  async deactivateNetworkCollaborator(accountId, collaboratorId) {
    const response = await api.patch(
      `/distributor/account/${accountId}/collaborators/${collaboratorId}/deactivate`
    )
    return response.data
  }

  async getCollaborator(collaboratorId) {
    const response = await api.get('/account/collaborator/' + collaboratorId)
    return response.data
  }

  async createCollaborator(data) {
    const response = await api.post('/distributor/collaborator', data)
    return response.data
  }

  async createLoginCollaborator(data) {
    const response = await api.post('/auth/login/collaborator', data)
    return response.data
  }

  async updateCollaborator(data) {
    const response = await api.put('/distributor/collaborator', data)
    return response.data
  }

  async switchCollaborator(collaboratorId) {
    await api.post('/account/collaborator/switch/' + collaboratorId)
  }
}

export default new CollaboratorsService()
